import { CCB, FEB, FINWISE, SET_DATA } from 'helpers/Constants';
import { TERTIARY_TEXT } from 'styles/Colors';
import { useDispatch, useSelector } from 'react-redux';
// import Checkbox from '@mui/material/Checkbox';
import Checkbox from 'components/forms/Checkbox';
import React from 'react';

const containerStyle = {
  alignItems: 'start',
  color: TERTIARY_TEXT,
  display: 'flex'
};

const footerStyle = {
  fontSize: '87.5%',
  fontStyle: 'italic',
  marginTop: '0.5rem'
};

function label(provider) {
  const isBankProduct = Boolean(provider);
  return (
    <>
      {!isBankProduct && (
        <div>
          I authorize OppLoans and its affiliates to initiate calls and text
          messages to any phone number I have provided, using an automatic
          telephone dialing system. This authorization includes assisting you
          with the completion of your application, whether or not such messaging
          is deemed to serve a marketing function in whole or in part.
        </div>
      )}
      {isBankProduct && (
        <div>
          I authorize OppLoans and its affiliates, and on behalf of {provider},
          to initiate calls and text messages to any phone number I have
          provided, using an automatic telephone dialing system. This
          authorization includes assisting you with the completion of your
          application, whether or not such messaging is deemed to serve a
          marketing function in whole or in part.
        </div>
      )}
      <div style={footerStyle}>
        This authorization is not required to get a loan from us.
      </div>
    </>
  );
}

function MarketingDisclosure({ style = {} }) {
  const productOwner = useSelector((state) => state.productOwner);
  const marketingDisclosure = useSelector((state) => state.marketingDisclosure);
  const dispatch = useDispatch();
  let provider = '';

  switch (productOwner) {
    case FINWISE:
      provider = 'FinWise Bank';
      break;
    case FEB:
      provider = 'First Electronic Bank';
      break;
    case CCB:
      provider = 'CCBank';
      break;
    default:
      break;
  }

  return (
    <div css={[containerStyle, style]}>
      <Checkbox
        id='marketingDisclosure'
        name='marketingDisclosure'
        value={marketingDisclosure || false}
        checked={marketingDisclosure || false}
        onChange={(e) => {
          dispatch({
            type: SET_DATA,
            payload: { marketingDisclosure: e.target.checked }
          });
        }}
        additionalCheckboxStyle={{ borderRadius: 0 }}
        additionalLabelStyle={{
          fontSize: '10px',
          display: 'flex',
          placeItems: 'center stretch',
          padding: '0.5rem'
        }}
      />
      <span>{label(provider)}</span>
    </div>
  );
  //     id='registration_disclaimers_marketing_disclosure'
}

export default MarketingDisclosure;
